import "@/App.css";
import { CircleGame } from "./components/CircleGame";

function App() {
  return (
    <div className="App">
      <CircleGame />
    </div>
  );
}

export default App;
